import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import changeUserPassword from '../../services/changeUserPassword';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import translateString from "../../utils/Locales";

let t = translateString;

export default class UserSettings extends React.Component {

  constructor(props){
    super (props)
    this.state = {
      error: false, 
      errorMessage: '',
      oldPassword: '', 
      newPassword: '', 
      confirm: '',
    }

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
  }


  async componentDidMount(){

    this.setState({});
  }

  render () {

    return (
      <>
        <PageTitle title={t('impostazioni_profilo')} />

          <div style={containerView}>
          <p style={{ color: 'darkgrey', fontWeight: 'bold', marginLeft: '5px', marginTop: '40px' }}>{t('modifica_password')}: </p>
          { this.state.error && <p style={{color: 'red', fontWeight: 'bold', width: '100%', paddingLeft: '5px', paddingRight: '20px', marginTop: '5px' }}>{this.state.errorMessage}</p> }
          <TextInput name={t('password_attuale')} type={"password"} value={this.state.oldPassword} 
            onChange={(text) => { this.setState({oldPassword: text})}
          } />
          <TextInput name={t('nuova_password')} type={"password"} value={this.state.newPassword} 
            onChange={(text) => { this.setState({newPassword: text})}
          } />
          <TextInput name={t('conferma_nuova_password')} type={"password"} value={this.state.confirm} 
            onChange={(text) => { this.setState({confirm: text})}
          } />
          <br/>
          <FixButton style={{cursor: 'pointer'}} title={t('aggiorna_password')} callback={async () => {
              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });

              if (this.state.oldPassword == '' || this.state.newPassword == '' || this.state.confirm == '') {
                this.setState({ error: true, errorMessage: t('verifica_dati')});
                setTimeout(() => {
                  this.setState({ error: false });
                }, 2000);
                return;
              } else if (this.state.newPassword != this.state.confirm) {
                this.setState({ error: true, errorMessage: t('password_non_coincidono')});
                setTimeout(() => {
                  this.setState({ error: false });
                }, 2000);
                return;
              }

              let ret = await changeUserPassword(username, token, this.state.oldPassword, this.state.newPassword);
              if (ret.success == 'wrong_pass'){
                this.setState({ error: true, errorMessage: t('password_a_nc')});
                setTimeout(() => {
                  this.setState({ error: false });
                }, 2000);
              } else {
                alert (t('password_modificata'));
                this.setState({ oldPassword: '', newPassword: '', confirm: '' });
                window.location.href =  '/' + this.dbPath + '/#/app/dashboard';
              }
          }} />
          </div>
      </>
    );
  }

}

const containerView = {
    backgroundColor: 'white', 
    borderRadius: '10px', 
    paddingTop: '5px',
    paddingBottom: '20px',
    paddingLeft: '40px',
    boxShadow: '0px 2px 10px lightgrey', 

}

